import { debounce } from 'lodash';

const MAX_QUEUE_TIME = 1000;

const refreshKpiRegistration = debounce(
  dispatch => {
    dispatch('STATS/commitKpiSubscription');
  },
  MAX_QUEUE_TIME,
  {
    leading: false,
    trailing: true
  }
);

/**
 * Plugin for handling KPI subscription changes, to refresh all server-side KPI registrations.
 * @param store
 */
export default store => {
  store.subscribe((mutation, state) => {
    if (['STATS/addKpiSubscription', 'STATS/removeKpiSubscription'].includes(mutation.type)) {
      refreshKpiRegistration(store.dispatch);
    }
  });
};
